/** Run the established v2 analysis pipeline. */

export const ANALYSIS_PIPELINE_PHASES = ["extracting", "classifying", "analysis_generating"];

export function analysisPhaseLabel(phase) {
  switch (phase) {
    case "extracting":
      return "Extracting the selected PDF pages…";
    case "building_units":
      return "Building document sections…";
    case "classifying":
      return "Classifying products by section…";
    case "classified":
      return "Section map ready. Generating analysis…";
    case "analysis_generating":
      return "Extracting analysis fields from the document…";
    case "analysis_generated":
      return "Analysis ready.";
    default:
      return "";
  }
}

/**
 * @param {string} jobId
 * @param {object} options
 * @param {import('axios').AxiosInstance} options.http
 * @param {string} options.apiBase e.g. "/api"
 * @param {(phase: string) => void} [options.onPhase]
 */
export async function runAnalysisPipeline(jobId, { http, apiBase, onPhase }) {
  if (!jobId) throw new Error("Job ID is required");
  onPhase?.("extracting");
  const res = await http.post(`${apiBase}/rfp-jobs/${jobId}/analysis/v2/run`, null, {
    timeout: 900_000,
  });
  onPhase?.("analysis_generated");
  return res.data;
}
